import { CheckIcon, XIcon } from "@heroicons/react/outline";

import { ColumnType, ReportColumn, ReportScore } from "@/types/evaluate";

export const sortColumns = (columns: ReportColumn[]) =>
  [...columns].sort((a, b) => a.position - b.position);

export const SUCCEED_BOOLEAN_THRESHOLD = 80;

const getScoreColor = (scoreValue: number): string => {
  if (scoreValue === 100) {
    return "text-green-500 font-semibold";
  }

  if (scoreValue > SUCCEED_BOOLEAN_THRESHOLD) {
    return "text-gray-600";
  }

  return "text-red-500 font-semibold";
};

export const evaluationScoreText = (
  score: ReportScore | null,
  iconClass = "mr-1 inline h-3.5 w-auto",
): {
  scoreFormatted: string;
  scoreText: string;
  scoreColor: string;
  scoreIcon: React.ReactNode | null;
} => {
  if (!score) {
    return {
      scoreFormatted: "",
      scoreText: "",
      scoreColor: "",
      scoreIcon: null,
    };
  }

  let scoreText = "";
  let scoreColor = "";
  let scoreFormatted = "";
  let scoreIcon = null;
  // eslint-disable-next-line no-param-reassign
  score = (score.type && score) || { type: typeof score, value: score };

  if (score.type === "boolean") {
    scoreFormatted = `${score.value.toFixed(0)}%`;
    scoreText = score.value === 100 ? "Pass" : `${score.value.toFixed(0)}% passing`;
    scoreColor = getScoreColor(score.value);
    scoreIcon =
      score.value > SUCCEED_BOOLEAN_THRESHOLD ? (
        <CheckIcon className={iconClass} />
      ) : (
        <XIcon className={iconClass} />
      );
  } else if (score.type === "number") {
    scoreFormatted = score.value.toFixed(2);
    scoreText = `Score: ${score.value.toFixed(2)}`;
    scoreColor = "text-gray-600";
    scoreIcon = <CheckIcon className={iconClass} />;
  }

  return { scoreFormatted, scoreText, scoreColor, scoreIcon };
};

export const reportScoreForVersionList = (score: ReportScore | null) => {
  const { scoreText, scoreColor, scoreIcon } = evaluationScoreText(score);
  return scoreText ? (
    <div className={`flex items-center justify-between ${scoreColor}`}>
      {scoreIcon}
      {scoreText}
    </div>
  ) : null;
};

export const formatInputVariable = (columnType: string, inputVariable: string) => {
  let icon = "";
  if (columnType === ColumnType.DATASET.toString()) {
    return `{${inputVariable}}`;
  } else if (columnType === ColumnType.ENDPOINT.toString()) {
    icon = "🔗 ";
  } else if (
    columnType === ColumnType.PROMPT_TEMPLATE.toString() ||
    columnType === ColumnType.WORKFLOW.toString()
  ) {
    icon = "✨ ";
  }
  return `${icon}${inputVariable}`;
};
